export async function buildDeviceFingerprint() {
  if (typeof window === 'undefined' || !window.crypto?.subtle) {
    return ''
  }

  const fingerprintSource = [
    navigator.userAgent,
    navigator.language,
    navigator.platform,
    String(window.screen.width),
    String(window.screen.height),
    String(window.devicePixelRatio || 1),
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    String(navigator.hardwareConcurrency || 0),
  ].join('||')

  const encoded = new TextEncoder().encode(fingerprintSource)
  const digest = await window.crypto.subtle.digest('SHA-256', encoded)

  return Array.from(new Uint8Array(digest))
    .map((item) => item.toString(16).padStart(2, '0'))
    .join('')
}